/**
 * Root Store
 */
class RootStore {
    constructor() {
        this.state = {
            // Array to store FIS users
            fisUsers: []
        };
        // Read version from package.json
        this.version = this.getVersionFromPackage();
    }

    /**
     * Get version from package.json
     * @returns {string} Version string from package.json
     */
    getVersionFromPackage() {
        return '1.0.12';
    }

    /**
     * Set FIS users in the store
     * @param {Array} users - Array of FIS users
     */
    setFISUsers(users) {
        this.state.fisUsers = users;
    }

    /**
     * Get FIS users from the store
     * @returns {Array} Array of FIS users
     */
    getFISUsers() {
        return this.state.fisUsers;
    }

    /**
     * Get the current application version
     * @returns {string} Current version string
     */
    getVersion() {
        return this.version;
    }
}

export default RootStore;